const setResumeTemplate = (resumeTemplate) => ({
    type: 'SET_RESUME_TEMPLATE',
    resumeTemplate,
});

export default setResumeTemplate;
